import PropTypes from 'prop-types';
import React from 'react';
import ArrowDown from './icons/ArrowDown';

export type MenuItemProps = {
    icon: React.ReactNode;
    title?: string;
    link?: string;
    active?: boolean;
    dropdown?: boolean;
    onClick: () => void;
    className: string;
};
export default function MenuItem({
    icon,
    title,
    link,
    active = false,
    dropdown = false,
    ...passThroughProps
}: MenuItemProps) {
    const Item = link ? 'a' : 'button';

    const anchorProps = {
        title,
        'aria-current': active,
        className: 'top-bar__menu-item',
        href: '',
        'aria-expanded': false,
    };

    if (link) {
        anchorProps.href = link;
    } else {
        anchorProps['aria-expanded'] = active;
    }

    if (active) {
        anchorProps.className += ' top-bar__menu-item--is-selected';
    }

    return (
        <Item {...anchorProps} {...passThroughProps}>
            {icon}
            <span className="top-bar__menu-item__title">{title}</span>
            {dropdown && (
                <span className="top-bar__menu-item__arrow">
                    <ArrowDown />
                </span>
            )}
        </Item>
    );
}

MenuItem.defaultProps = {
    link: null,
    active: false,
    dropdown: false,
    title: undefined,
};

MenuItem.propTypes = {
    icon: PropTypes.element.isRequired,
    title: PropTypes.node,
    link: PropTypes.string,
    active: PropTypes.bool,
    dropdown: PropTypes.bool,
};
